import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ReactComponent as Search } from "../../assets/icons/search.svg";
import { db } from "../../utils/firebase";
import { tutorActions } from "../../utils/store/selectedTutor.js";
import Navbar from "../navbar";
import ReviewForm from "./reviewForm";
import "./style.css";
import TutorCard from "./tutorCard";

const ReviewHome = () => {
  const dispatch = useDispatch();
  const setSelectedTutor = (tutor) => {
    dispatch(tutorActions.set(tutor));
  };
  const thisUser = useSelector((state) => state.thisUser.user);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [tutors, setTutors] = useState(null);
  const [orderedTutors, setOrderedTutors] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filteredTutors, setFilteredTutors] = useState(null);

  const fetchTutorsData = async () => {
    const querySnapshot = await getDocs(collection(db, "tutors"));
    let data = [];
    querySnapshot.forEach((doc) => {
      data.push({ ...doc.data(), id: doc.id });
    });

    setTutors(data);
  };

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
        navigate("/login");
      }
    });
  });

  useEffect(() => {
    const fetchData = async () => {
      await fetchTutorsData();
    };
    if (user) fetchData();
    setSelectedTutor(null);
  }, [user]);

  // SG 08/06/2022 22:32  putting reviewed tutor(s) at the end of array
  useEffect(() => {
    if (tutors) {
      let reviewed = [];
      let unreviewed = [...tutors];
      tutors.forEach((tutor) => {
        for (let i = 0; i < tutor.reviews.reviewers.length; i++) {
          let reviewer = tutor.reviews.reviewers[i];
          if (reviewer.id === thisUser.id) {
            reviewed.push(tutor);
            unreviewed.splice(unreviewed.indexOf(tutor), 1);
            break;
          }
        }
      });
      setOrderedTutors(unreviewed.concat(reviewed));
    }
  }, [tutors]);

  useEffect(() => {
    if (orderedTutors) {
      const copiedArray = [...orderedTutors];
      if (copiedArray) {
        let removeList = [];
        copiedArray.forEach((tutor) => {
          const tutorName = `${tutor.firstName} ${tutor.lastName}`;
          if (!tutorName.toUpperCase().includes(searchKeyword.toUpperCase())) {
            removeList.push(tutor);
          }
        });
        for (const t of removeList) {
          const index = copiedArray.indexOf(t);
          copiedArray.splice(index, 1);
        }
        setFilteredTutors(copiedArray);
      }
    }
  }, [searchKeyword]);

  if (!user) return null;

  return (
    <div>
      <Navbar user={user} />
      <div className="overflow-hidden h-full w-full pt-5 md:pt-10">
        <div className="px-10">
          <p className="text-[1.8em] md:text-[2em] font-semibold text-gray-700">
            Who are you writing a review for?
          </p>
        </div>
        <div className="flex items-center ml-5 px-5 md:px-10 w-full">
          <Search />
          <input
            onChange={(e) => {
              setSearchKeyword(e.target.value);
              setSelectedTutor(null);
            }}
            value={searchKeyword}
            placeholder="Search name"
            className="text-[1.4em] outline-none bg-transparent m-5 text-gray-800 w-[10em]"
          />
        </div>
        <div className="overflow-x-auto whitespace-nowrap py-7 scrollableCardHolder px-5">
          {filteredTutors
            ? filteredTutors.map((tutor, index) => {
                return (
                  <TutorCard
                    tutor={tutor}
                    thisUser={thisUser}
                    key={Math.random()}
                  />
                );
              })
            : orderedTutors &&
              orderedTutors.map((tutor, index) => {
                return (
                  <TutorCard
                    tutor={tutor}
                    thisUser={thisUser}
                    key={Math.random()}
                  />
                );
              })}
        </div>
      </div>

      <ReviewForm thisUser={thisUser} />
    </div>
  );
};

export default ReviewHome;
